import 'components/shared/Communications.module.scss'

import { useField } from 'react-final-form'
import CommunicationInput, { TaggedConversation } from 'components/communication-input/CommunicationInput'
import React from 'react'

export const WrappedCommunicationInput = (props: {
  accountId?: string
  name: string
  label: string
  isEditorTall?: boolean
}) => {
  const { input } = useField<TaggedConversation>(props.name)
  return (
    <CommunicationInput
      accountId={props.accountId}
      value={input?.value?.json}
      onChange={input.onChange}
      label={props.label}
      isEditorTall={props.isEditorTall}
    />
  )
}
